import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BASE_URL = 'https://uploadtourl.com';
const DEFAULT_TITLE = 'Upload to URL - Instant File Hosting with API Access';
const DEFAULT_DESCRIPTION = 'Upload files and get instant public URLs. API-first file hosting service for developers with n8n, Pipedream, Zapier, and Make integrations.';

/**
 * Updates document title, meta description, and Open Graph / Twitter tags per page.
 * Falls back to defaults on unmount so navigating away restores the base meta.
 */
export default function usePageMeta({ title, description } = {}) {
  const { pathname } = useLocation();

  useEffect(() => {
    const pageTitle = title || DEFAULT_TITLE;
    const pageDescription = description || DEFAULT_DESCRIPTION;
    const pageUrl = `${BASE_URL}${pathname === '/' ? '/' : pathname}`;

    document.title = pageTitle;

    const setMeta = (selector, attr, value) => {
      const el = document.querySelector(selector);
      if (el) el.setAttribute(attr, value);
    };

    setMeta('meta[name="description"]', 'content', pageDescription);
    setMeta('meta[property="og:title"]', 'content', pageTitle);
    setMeta('meta[property="og:description"]', 'content', pageDescription);
    setMeta('meta[property="og:url"]', 'content', pageUrl);
    setMeta('link[rel="canonical"]', 'href', pageUrl);
    setMeta('meta[name="twitter:title"]', 'content', pageTitle);
    setMeta('meta[name="twitter:description"]', 'content', pageDescription);

    return () => {
      document.title = DEFAULT_TITLE;
      setMeta('meta[name="description"]', 'content', DEFAULT_DESCRIPTION);
      setMeta('meta[property="og:title"]', 'content', DEFAULT_TITLE);
      setMeta('meta[property="og:description"]', 'content', DEFAULT_DESCRIPTION);
      setMeta('meta[property="og:url"]', 'content', `${BASE_URL}/`);
      setMeta('meta[name="twitter:title"]', 'content', DEFAULT_TITLE);
      setMeta('meta[name="twitter:description"]', 'content', DEFAULT_DESCRIPTION);
    };
  }, [title, description, pathname]);
}
